export default __webpack_public_path__ + "static/media/ASU Theories of Second Language Acquisition.fa8811e2.png";